import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFunctionsComponent } from "./med-icon-functions.component";

@NgModule({
  declarations: [
    MedIconFunctionsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFunctionsComponent,
  ],
})
export class MedIconFunctionsModule { }
